export class SpeciesIndustryReportRecord {

  readonly amount: number;

  readonly avgPrice: number;

  readonly avgWeight: number;

  readonly fisherNo: number;

  readonly lbsPurchased: number;

  readonly piecesPurchased: number;

  readonly reportsNumber: number;

  readonly yearMonth: string; /*only for species. null for industry*/

  readonly category: string;

  readonly species: string;

  /**
   * Converts JSON representation of name into {@link SpeciesIndustryReportRecord} instance.
   *
   * @param jsonObject JSON representation of species report record
   */
  static fromJSON(jsonObject: any): SpeciesIndustryReportRecord {
    const result = Object.create(SpeciesIndustryReportRecord.prototype);
    return Object.assign(result, jsonObject);
  }

}
